export default {
  template: "#vue-map-autocomplete",
  delimiters: ['${', '}'],
  data: function () {
    return {
      query: '',
      autocomplete_service: null,
      geocoder: null,
      predictions: [],
      show_predictions: false
    }
  },
  methods: {
    autoResults: function (e) {
      if (e.keyCode !== 13) {
        if (!this.autocomplete_service && this.query.length > 2) {
          this.autocomplete_service = new google.maps.places.AutocompleteService();
        } else if (this.autocomplete_service && this.query.length > 0) {
          this.show_predictions = true;
          this.autocomplete_service.getPlacePredictions({
            input: this.query,
            types: ['geocode'],
            componentRestrictions: {
              country: this.$store.state.country || 'ca'
            }
          }, this.displayAutoResults);
        } else {
          this.predictions = [];
        }
      }
    },
    displayAutoResults: function (predictions, status) {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        this.predictions = predictions;
      } else if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
        this.predictions = [];
      }
    },
    formSubmit: function (item) {
      let choice = this.predictions[0];
      if (item.place_id) {
        choice = item;
      } else {
        item.preventDefault();
      }
      if (this.query.length > 0 && choice) {
        this.geocoder = new google.maps.Geocoder();
        this.query = choice.description;
        this.geocoder.geocode({placeId: choice.place_id}, (place, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            this.predictions = [choice];
            this.show_predictions = false;
            this.$store.state.global_components.store_locator.updateClosestStores(
                place[0].geometry.location.lat(),
                place[0].geometry.location.lng()
            );
          }
        });
      } else {
        this.$store.state.global_components.store_locator.updateClosestStores();
      }
    }
  }
}